import { Reveal } from "./Reveal";

export const PageIntro = ({ kicker, children }) => (
  <Reveal className="mx-auto max-w-[1500px] px-6 md:px-12 pt-8 md:pt-14 pb-2" data-testid="page-intro">
    <p className="overline text-terracotta">{kicker}</p>
    <p className="mt-3 font-serif italic text-lg md:text-2xl text-stone max-w-3xl leading-snug">
      {children}
    </p>
  </Reveal>
);
